import { render } from "./articlesm.vue?vue&type=template&id=a21c1e56"
import script from "./articlesm.vue?vue&type=script&lang=js"
export * from "./articlesm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__